import { render, staticRenderFns } from "./4mTableImpr.vue?vue&type=template&id=b17272cc"
import script from "./4mTableImpr.vue?vue&type=script&lang=js"
export * from "./4mTableImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b17272cc')) {
      api.createRecord('b17272cc', component.options)
    } else {
      api.reload('b17272cc', component.options)
    }
    module.hot.accept("./4mTableImpr.vue?vue&type=template&id=b17272cc", function () {
      api.rerender('b17272cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/4mTableImpr.vue"
export default component.exports